"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var padding_1 = __importDefault(require("src/utilities/styled/padding"));
exports.default = (function (type) { return function (_a) {
    var theme = _a.theme, padding = _a.padding;
    if (padding === undefined) {
        return "padding: " + theme.buttons[type].padding + ";";
    }
    return (0, padding_1.default)({ theme: theme, padding: padding });
}; });
